import { useMemo } from "react";
import { City, Country, State } from "country-state-city";

export const useLocationOptions = (countryCode?: string, stateCode?: string) => {
  return useMemo(() => {
    const countries = Country.getAllCountries().map(c => ({ label: c.name, value: c.isoCode }));

    const states = countryCode
      ? State.getStatesOfCountry(countryCode).map(s => ({ label: s.name, value: s.isoCode }))
      : [];

    const cities = countryCode && stateCode
      ? City.getCitiesOfState(countryCode, stateCode).map(city => ({ label: city.name, value: city.name }))
      : [];

    return { countries, states, cities };
  }, [countryCode, stateCode]);
};
